import { ApiError } from '../api/client'

/**
 * Turn any thrown value into something worth showing a user.
 *
 * Pages must never surface a raw exception message from a network stack, and they must
 * never render "undefined". Everything funnels through here.
 */
export function messageFor(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.code === 'validation_error') {
      return 'Some of those details were not accepted. Please check and try again.'
    }
    if (error.status === 502 || error.status === 503) {
      return 'The service is starting up or briefly unavailable. Try again in a moment.'
    }
    return error.message
  }
  if (error instanceof TypeError) {
    // fetch rejects with a TypeError when the request never left the browser.
    return 'Could not reach the server. Check your connection and try again.'
  }
  if (error instanceof Error && error.message) return error.message
  return 'Something went wrong.'
}
